import { useEffect, useState } from 'react';

import { NetworkStatus } from '#/service/constants';

export const useOfflineNetwork = () => {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const setOnline = () => setIsOffline(false);
    const setOffline = () => setIsOffline(true);

    // Previously we were using navigator.onLine to distinguish initial user connection.
    // However, this caused inconsistent results as the value is not always correct.
    window.addEventListener(NetworkStatus.ONLINE, setOnline);
    window.addEventListener(NetworkStatus.OFFLINE, setOffline);

    return () => {
      window.removeEventListener(NetworkStatus.ONLINE, setOnline);
      window.removeEventListener(NetworkStatus.OFFLINE, setOffline);
    };
  }, []);

  return { isOffline };
};
